import shippingMethodsCodes from './shippingMethodsCodes';

const { PICKUP, CASTO, DPD, INPOST, DTS } = shippingMethodsCodes;

export default {
    [INPOST]: 'inpost',
    [PICKUP]: 'pickup',
    [DPD]: 'courier',
    [CASTO]: 'custom-delivery',
    [DTS]: 'dtsdc',
};
